









































































import { Component, Watch } from 'vue-property-decorator';
import SaascadaVueDialog from '@/components/Shared/SaascadaVueDialog';
import { DepositAccountSettingsModule } from '@/store/Accounts/DepositAccountSettingsModule';
import UpdateAccountDepositInterestSettingsRequest from '@/models/Accounts/DepositAccounts/Settings/UpdateAccountDepositInterestSettingsRequest';
import ListUtils from '@/lib/listUtils';
import InterestRateType from '@/models/Products/InterestRateType';
import { ProductDetailsModule } from '@/store/Products/ProductDetailsModule';

@Component({ name: 'AccountDepositInterestSettingsEditDialog' })
export default class extends SaascadaVueDialog {

    InterestRateType = InterestRateType;
    request: UpdateAccountDepositInterestSettingsRequest = new UpdateAccountDepositInterestSettingsRequest(DepositAccountSettingsModule.settings.depositInterestSettings, new Date());
    dialog = false;

    @Watch('dialog')
    async onDialogChanged(val: boolean) {
        if (val) {
            this.request = new UpdateAccountDepositInterestSettingsRequest(DepositAccountSettingsModule.settings.depositInterestSettings, new Date());
            await ProductDetailsModule.getRateSources();
        }
    }

    get settings() {
        return DepositAccountSettingsModule.settings.depositInterestSettings;
    }

    get interestRateTypeOptions() {
        return ListUtils.interestRateTypeOptions();
    }

    get rateSourceOptions() {
        return ProductDetailsModule.rateSources;
    }

    async save() {
        if (!(this.$refs.form as any).validate()) {
           return;
        }
        else {
            this.dialog = false;
            this.request.rateValue = +this.request.rateValue;
            await DepositAccountSettingsModule.editDepositInterestSettings(this.request);
        }
    }

}
